import { urlExam } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyCreateExam, IExam, IQueryGetExams } from '~/utils/interface/exam';

export const examApi = {
  getListExams(params: IQueryGetExams) {
    const url = `${urlExam.getList}`;
    return axiosClient.get<IBaseResponse<IListDataResponse<IExam[]>>>(url, { params });
  },

  createExam(body: IBodyCreateExam) {
    const url = `${urlExam.create}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};
